import React from 'react'
import PageTitle from '../../components/PageTitle'
import Layout from '../../components/Layout'
import { Button, Form, InputGroup, Col } from 'react-bootstrap'
import styled from 'styled-components'
import moment from 'moment'
import DayPicker from 'react-day-picker'
import 'react-day-picker/lib/style.css'
// import DatePicker from 'react-datepicker'
// import 'react-datepicker/dist/react-datepicker.css'

const MIN_REQUEST_DATE = moment().add(18, 'days').startOf('day');

const timeframe = days =>
  moment()
    .add(days, 'd')
    .format('YYYY-MM-DD')

const Text = props => (
  <Form.Group as={Col} md={props.md || '4'} controlId={props.label}>
    <Form.Label>{props.label}</Form.Label>
    <Form.Control
      required={props.required ? true : false}
      type="text"
      placeholder={props.placeholder || props.label}
      {...props}
    />
    {props.required && (
      <Form.Control.Feedback type="invalid">
        {props.feedback ||
          `Please provide a valid ${props.label.toLowerCase()}.`}
      </Form.Control.Feedback>
    )}
  </Form.Group>
)
const TextArea = props => (
  <Form.Group controlId={props.label}>
    <Form.Label>{props.label}</Form.Label>
    <Form.Control
      as="textarea"
      rows="3"
      required={props.required ? true : false}
      placeholder={props.placeholder || props.label}
      {...props}
    />
    {props.required && (
      <Form.Control.Feedback type="invalid">
        {props.feedback ||
          `Please provide a valid ${props.label.toLowerCase()}.`}
      </Form.Control.Feedback>
    )}
  </Form.Group>
)

const Row = props => <Form.Row>{props.children}</Form.Row>

class FormExample extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      validated: false,
      date: undefined,
      attached: false,
      customTitle: false,
    }
  }

  handleSubmit(event) {
    const form = event.currentTarget;
    const minAllowedDate = moment().add(18, 'days').startOf('day');

    // Basic HTML5 validation
    if (form.checkValidity() === false || this.state.date === undefined) {
      event.preventDefault();
      event.stopPropagation();
      this.setState({ validated: true })
      return;
    }

        // ---- EXTRA 18-DAY CHECK ----
    const selectedDate = moment(this.state.date);


    if (selectedDate.isBefore(minAllowedDate)) {
      event.preventDefault();
      event.stopPropagation();
      alert(`Please select a date at least 18 days from today (${minAllowedDate.format('MM/DD/YYYY')}).`);
      return;
    }
    // ----------------------------

    // Spam check
    const phone = document.querySelector('input[name="telephone"]').value;
    const needed = document.querySelector('input[name="dateNeeded"]').value;
    const code = parseInt(needed.replace(/[^\d]+/g, '')) + parseInt(phone.replace(/[^\d]/g, ''));
    document.querySelector('#verification').value = code;

    this.setState({ validated: true });
  }

  handleDate(date, { disabled }) {
    if (disabled) return;
    this.setState({ date });
  }

  handleAttached(prevState) {
    this.setState(prevState => ({
      attached: !prevState.attached,
    }))
  }
  customTitle() {
    this.setState({ customTitle: true })
  }

  render() {
    const { validated } = this.state
    const minAllowedDate = moment()
      .add(18, 'days')
      .startOf('day')
      .toDate();

    return (
      <Layout>
        <PageTitle name="New Information Request" site="OIRA" />
        <div>
          <Form
            noValidate
            validated={validated}
            action="https://oiraweb.ua.edu/api/projects/request"
            encType="multipart/form-data"
            method="POST"
            onSubmit={e => this.handleSubmit(e)}
            id="reqform"
          >
            <input type="hidden" name="act" value="create" />
            <input type="hidden" name="queue" value="4" />
            <input
              type="hidden"
              name="origin"
              value="Information Request Form"
            />
            <h3>Contact Info</h3>
            <Row key={this.state.customTitle}>
              {!this.state.customTitle && (
                <Form.Group
                  as={Col}
                  sm="2"
                  controlId="exampleForm.ControlSelect1"
                >
                  <Form.Label>Courtesy Title</Form.Label>
                  <Form.Control name="courtesy" as="select" required>
                    <option disabled value>
                      Title
                    </option>
                    <option value="Dr.">Dr.</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Ms.">Ms.</option>
                    <option value="Mr.">Mr.</option>
                    <option value="Mx.">Mx.</option>
                    {/* <option onClick={this.customTitle.bind(this)}>
                      Custom Entry
                    </option> */}
                  </Form.Control>
                </Form.Group>
              )}
              {this.state.customTitle === true && (
                <Text
                  label="Courtesy Title"
                  name="courtesy"
                  placeholder=""
                  required
                  md="2"
                />
              )}
              <Text
                label="First Name"
                name="firstName"
                required
                md="5"
                pattern="[A-Za-z\-]+"
              />
              <Text
                label="Last Name"
                name="lastName"
                required
                md="5"
                pattern="[A-Za-z\-]+"
              />
            </Row>
            <Row><Text label="Position" required md="6" name="position" />
            <Text label="Department" md="6" name="department" />
            </Row>
            <Row>
              <Text label="College" md="6" name="college" />
              <Text label="Company" md="6" name="company" />
            </Row>
            <Row>
              <Text
                label="Telephone Number"
                name="telephone"
                md="6"
                required
                pattern="^[0-9\-+s\(\)]*$"
              />
              <Text
                label="Email Address"
                name="email"
                md="6"
                required
                pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,4}$"
              />
            </Row>
            <Row>
              <Text
                label="Mailing Address"
                name="mailingAddress"
                required
                minLength="5"
                md="12"
              />
            </Row>
            <Row>
              <Text label="City" name="city" required md="6" />
              <Form.Group as={Col} md="3" controlId="validationCustom04">
                <Form.Label>State</Form.Label>
                <Form.Control name="state" as="select" placeholder="State">
                  <option disabled selected value>
                    State
                  </option>
                  <option value="AL">AL</option>
                  <option value="AK">AK</option>
                  <option value="AZ">AZ</option>
                  <option value="AR">AR</option>
                  <option value="CA">CA</option>
                  <option value="CO">CO</option>
                  <option value="CT">CT</option>
                  <option value="DE">DE</option>
                  <option value="FL">FL</option>
                  <option value="GA">GA</option>
                  <option value="HI">HI</option>
                  <option value="ID">ID</option>
                  <option value="IL">IL</option>
                  <option value="IN">IN</option>
                  <option value="IA">IA</option>
                  <option value="KS">KS</option>
                  <option value="KY">KY</option>
                  <option value="LA">LA</option>
                  <option value="ME">ME</option>
                  <option value="MD">MD</option>
                  <option value="MA">MA</option>
                  <option value="MI">MI</option>
                  <option value="MN">MN</option>
                  <option value="MS">MS</option>
                  <option value="MO">MO</option>
                  <option value="MT">MT</option>
                  <option value="NE">NE</option>
                  <option value="NV">NV</option>
                  <option value="NH">NH</option>
                  <option value="NJ">NJ</option>
                  <option value="NM">NM</option>
                  <option value="NY">NY</option>
                  <option value="NC">NC</option>
                  <option value="ND">ND</option>
                  <option value="OH">OH</option>
                  <option value="OK">OK</option>
                  <option value="OR">OR</option>
                  <option value="PA">PA</option>
                  <option value="RI">RI</option>
                  <option value="SC">SC</option>
                  <option value="SD">SD</option>
                  <option value="TN">TN</option>
                  <option value="TX">TX</option>
                  <option value="UT">UT</option>
                  <option value="VT">VT</option>
                  <option value="VA">VA</option>
                  <option value="WA">WA</option>
                  <option value="WV">WV</option>
                  <option value="WI">WI</option>
                  <option value="WY">WY</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Please provide a valid state.
                </Form.Control.Feedback>
              </Form.Group>
              <Text
                pattern="[0-9\-]*"
                minLength="5"
                label="Zip Code"
                name="zip"
                md="3"
              />
            </Row>
            <br />
            <h3>Request</h3>
            <Row>
              <Form.Group md="4" controlId="Date Needed">
                <Form.Label>
                  Date Needed
                  {this.state.date && (
                    <>
                      :{' '}
                      <span style={{ color: 'red', fontWeight: 600 }}>
                        {moment(this.state.date).format('MM/DD/YYYY')}
                      </span>
                    </>
                  )}
                </Form.Label>
                <Form.Control
                  style={{ display: 'none' }}
                  required={true}
                  name="dateNeeded"
                  value={
                    this.state.date
                      ? moment(this.state.date).format('MM/DD/YYYY')
                      : ''
                  }
                />
                <br/>

                  <DayPicker
                    month={minAllowedDate}
                    selectedDays={this.state.date}
                    disabledDays={[
                      { daysOfWeek: [0, 6] },
                      {
                        before: minAllowedDate,
                        after: moment(minAllowedDate).add(360, 'days').toDate(),
                      },
                    ]}
                    onDayClick={this.handleDate.bind(this)}
                  />
                  
                <Form.Control.Feedback type="invalid">
                  Please provide a date at least 18 days from now.
                </Form.Control.Feedback>
                
                  {/* <DatePicker
                    inline
                    selected={this.state.date}
                    onChange={this.handleDate.bind(this)}
                    minDate={timeframe(10)}
                    maxDate={timeframe(360)}
                  /> */}
                
              </Form.Group>
            </Row>
            <Row>
              <Form.Group
                as={Col}
                sm="4"
                controlId="exampleForm.ControlSelect1"
              >
                <Form.Label>Affiliation</Form.Label>
                <Form.Control required name="affiliation" as="select">
                  <option value="0">
                    &nbsp;
                  </option>
                  <option disabled value>
                    Affiliation
                  </option>
                  <option>UA Student</option>
                  <option>UA Teaching and Research Faculty</option>
                  <option>UA Staff or Administrative Faculty</option>
                  <option>Other College or University</option>
                  <option>Higher Education Non-Gov. Organization</option>
                  <option>Media</option>
                  <option>State or Federal Agency</option>
                  <option>Other</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Please provide a valid affiliation.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <TextArea
              required
              label="Description"
              minLength="25"
              name="description"
              feedback="Description should be at least 25 characters long."
            />
            <TextArea
              required
              label="Purpose"
              name="usage"
              minLength="25"
              feedback="Description should be at least 25 characters long."
            />
            <Form.Group controlId="attachments">
              <p>
                If supporting attachments are needed, we will contact you after the request is received.  If your request requires completion on an accelerated timeline, please note this in the form description and we will reach out to discuss next steps.
              </p>
              <Form.Check
                type="checkbox"
                name="attachments"
                label="I need to submit supporting files or documents"
                onChange={this.handleAttached.bind(this)}
              />
            </Form.Group>

            <Button type="submit" disabled={this.state.submitting}>
              {this.state.submitting ? 'processing...' : 'Submit form'}
            </Button>
            <input type="hidden" id="verification" name="verification" style={{display:'none'}}/>
          </Form>
        </div>
      </Layout>
    )
  }
}

export default FormExample
